const TEMPLATE_CHROME_PATTERNS: RegExp[] = [
  /powered by boom/gi,
  /we found similar[^.!?]*[.!?]?/gi,
  /view (?:this )?(?:email|message) in (?:your )?browser/gi,
  /if you['’]?re having trouble viewing this email[^.!?]*[.!?]?/gi,
  /can['’]?t see this (?:email|message)\??/gi,
  /unsubscribe(?: from these emails)?/gi,
  /manage (?:your )?(?:email )?preferences/gi,
  /this (?:is an automated|email was sent)[^.!?]*[.!?]?/gi,
  /do not reply to this (?:email|message)/gi,
  /sent (?:with|via|from) boom/gi,
  /all rights reserved/gi,
  /©\s*\d{4}[^|]*/g
];

const HTML_ENTITIES: Record<string, string> = {
  "&nbsp;": " ",
  "&amp;": "&",
  "&lt;": "<",
  "&gt;": ">",
  "&quot;": '"',
  "&#39;": "'",
  "&apos;": "'"
};

const decodeEntities = (value: string) =>
  value
    .replace(
      /&nbsp;|&amp;|&lt;|&gt;|&quot;|&#39;|&apos;/g,
      (match) => HTML_ENTITIES[match] ?? match
    )
    .replace(/&#(\d+);/g, (_, code: string) =>
      String.fromCharCode(Number(code))
    );

const stripHtml = (value: string) =>
  value
    .replace(/<(script|style)[^>]*>[\s\S]*?<\/\1>/gi, " ")
    .replace(/<[^<>]*>/g, " ");

const stripUrls = (value: string) =>
  value.replace(/https?:\/\/\S+/gi, " ").replace(/\bwww\.\S+/gi, " ");

const collapseWhitespace = (value: string) => value.replace(/\s+/g, " ").trim();

const stripTemplateChrome = (value: string) =>
  TEMPLATE_CHROME_PATTERNS.reduce(
    (acc, pattern) => acc.replace(pattern, " "),
    value
  );

const stripLeadingPunctuation = (value: string) =>
  value.replace(/^[\s|·•\-–—:,.]+/, "");

export const stripMarkupForText = (value: string): string => {
  const hasMarkup =
    /<[a-z!/][^>]*>/i.test(value) || /@(?:font-face|media)\b/i.test(value);
  if (!hasMarkup) return value;
  let text = decodeEntities(stripHtml(value));
  let previous;
  do {
    previous = text;
    text = text
      .replace(/(^|[\s;}])@[a-z-]+[^;{}\n]{0,200}(?=\{)/gi, "$1")
      .replace(/\{[^{}]*\}/g, " ");
  } while (text !== previous);

  return text
    .replace(/[ \t]+/g, " ")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
};

export const buildMessageSnippet = (
  body: string | null | undefined,
  subject?: string | null
): string => {
  const cleaned = stripLeadingPunctuation(
    collapseWhitespace(
      stripTemplateChrome(stripUrls(decodeEntities(stripHtml(body ?? ""))))
    )
  );

  if (cleaned) return cleaned;

  return collapseWhitespace(decodeEntities(stripHtml(subject ?? "")));
};
